import { Component, forwardRef, Input, OnInit, ViewChild } from "@angular/core";
import { FilterCardWithCode } from "app/modules/dashboard/constants/filters";
import { GridComponent } from "app/modules/shared/components/grid/grid.component";

@Component({
  selector: "kl-unit-set-list",
  templateUrl: "./unit-set-list.component.html",
  styleUrls: ["./unit-set-list.component.scss"],
})
export class UnitSetListComponent implements OnInit {
  filterSelectItems = FilterCardWithCode;
  @Input() mode: string;
  @Input() tabId: string;
  @Input() modalId: string;
  @ViewChild(forwardRef(() => GridComponent), {
    static: true,
  })
  private gridComponent: GridComponent;

  constructor() {}

  ngOnInit() {
    if (this.mode) {
      this.gridComponent.mode = this.mode;
    }
  }
}
